import { computed, Ref, ref } from "vue"

export type FetchWrapper = {
    isFetching: Ref<boolean>
    hasError: Ref<boolean>
    isSuccess: Ref<boolean>
    fetch: (kwargs?: any) => Promise<void>
    error: Ref<Error | null>
    cancel: () => void
}

/**
 * Fonction utilitaire pour fetch des appel API.
 * Renvoie la fonction de fetch et des états de chargement
 * @returns
 */
export const useFetchWrapper = (
    callback: (kwargs?: any, controller?: AbortController) => Promise<void>
): FetchWrapper => {
    const isFetching = ref(false)

    const isSuccess = ref(false)
    const error = ref<Error | null>(null)

    let controller = new AbortController()

    function cancel() {
        isFetching.value = false
        isSuccess.value = false
        error.value = null
        controller.abort()
    }

    const fetch = async (kwargs?: any) => {
        isFetching.value = true
        isSuccess.value = false
        error.value = null
        controller = new AbortController()
        try {
            await callback(kwargs, controller)
            isSuccess.value = true
        } catch (err) {
            const innerError = err as Error
            error.value = innerError
        } finally {
            isFetching.value = false
        }
    }

    const hasError = computed(() => !!error.value)

    return { isFetching, hasError, isSuccess, fetch, error, cancel }
}
